<template>
<ul>
  <input-tree-item
    v-for="(item, index) in treeData"
    :key="index"
    :model="item"
    :value.sync="value"
    :label="label"
    @filterValueChanged="$emit('filterValueChanged')">
  </input-tree-item>
</ul>
</template>

<script>
export default {
  name: 'InputTree',
  props: {
    label: String,
    treeData: Array,
    value: Object,
    model: Object
  }
}
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
</style>
